module.exports = __webpack_public_path__ + "it.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/it.svg
// module id = 876
// module chunks = 0